import Image from "./Image";

function ScrollableGallery({ pics }) {
  return (
    <>
      {pics.map((pic, index) => (
        <div key={index} className="cursor-pointer shrink-0 w-auto h-auto mr-4">
          <Image src={pic}/>
          <p className="font-normal mt-2.5 text-base">{pic.title}</p>
        </div>
      ))}
    </>
  );
}

export default ScrollableGallery;
